module.exports = __webpack_public_path__ + "static/media/founder-tiny.721a5f5d.svg";